import { useCallback } from "react"
import { extractErrorMessage } from "src/common/errorHandling/extractErrorMessage/extractErrorMessage"

export const useExtractErrorMessage = () => {
	return useCallback((error: unknown) => extractErrorMessage(error), [])
}
